const US = () => (
  <svg viewBox="0 0 20 14">
    {[0, 2, 4, 6, 8, 10, 12].map((y) => <rect key={y} y={y} width="20" height="1.08" fill="#B22234" />)}
    <rect width="20" height="14" fill="#fff" opacity="0" />
    <rect width="8.6" height="7.5" fill="#3C3B6E" />
  </svg>
);
const UK = () => (
  <svg viewBox="0 0 20 14">
    <rect width="20" height="14" fill="#012169" />
    <path d="M0 0L20 14M20 0L0 14" stroke="#fff" strokeWidth="2.6" />
    <path d="M0 0L20 14M20 0L0 14" stroke="#C8102E" strokeWidth="0.9" />
    <path d="M10 0v14M0 7h20" stroke="#fff" strokeWidth="4" />
    <path d="M10 0v14M0 7h20" stroke="#C8102E" strokeWidth="2.2" />
  </svg>
);
const EU = () => (
  <svg viewBox="0 0 20 14">
    <rect width="20" height="14" fill="#003399" />
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i / 12) * Math.PI * 2;
      return <circle key={i} cx={10 + Math.cos(a) * 4.2} cy={7 + Math.sin(a) * 4.2} r="0.6" fill="#FFCC00" />;
    })}
  </svg>
);
const IN = () => (
  <svg viewBox="0 0 20 14">
    <rect width="20" height="4.67" fill="#FF9933" />
    <rect y="4.67" width="20" height="4.67" fill="#fff" />
    <rect y="9.33" width="20" height="4.67" fill="#138808" />
    <circle cx="10" cy="7" r="1.7" fill="none" stroke="#000080" strokeWidth="0.45" />
  </svg>
);

const MAP = { us: [US, "USA"], uk: [UK, "UK"], eu: [EU, "EMEA"], apac: [IN, "APAC"] };

export const Flag = ({ id, className = "w-5" }) => {
  const [Svg, label] = MAP[id];
  return (
    <span title={label} aria-label={label} role="img" className={`inline-block overflow-hidden rounded-[2px] ring-1 ring-black/15 ${className}`}>
      <Svg />
    </span>
  );
};

export const FlagRow = ({ ids = ["us", "uk", "eu", "apac"], className = "", size = "w-5" }) => (
  <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="flag-row">
    {ids.map((id) => (
      <span key={id} className="opacity-80 grayscale-[35%] transition duration-300 hover:opacity-100 hover:grayscale-0 hover:-translate-y-0.5">
        <Flag id={id} className={size} />
      </span>
    ))}
  </span>
);
